import { render, staticRenderFns } from "./FilterDeliveryPeriod.vue?vue&type=template&id=7f163056"
import script from "./FilterDeliveryPeriod.vue?vue&type=script&lang=ts"
export * from "./FilterDeliveryPeriod.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports